<template>
  <section class="bg-blue-light pad-y-60 text-center">
    <div class="container">
      <div
        data-aos="fade-down"
        class="heading text-center with-border aos-init aos-animate"
      >
        <h2 class="title text-uppercase text-teal-dark">Himbauan</h2>
      </div>

      <p class="">
        Demi kenyamanan bersama, Kami menghimbau kepada Bapak/Ibu/Saudara/i yang
        berkesempatan dan berkenan hadir pada upacara Pawiwahan Kami, agar
        senantiasa mengikuti arahan Pemerintah terkait protokol kesehatan di
        tengah Pandemi Covid-19 ini.
      </p>

      <div class="d-flex justify-content-center py-5">
        <div class="row justify-content-center" style="max-width: 800px">
          <div
            class="col-4 col-md-4 d-flex justify-content-center"
            v-for="item in instructions"
            :key="item.title"
          >
            <div class="mb-4 w-100">
              <img :src="item.icon" style="max-width: 125px; width: 70%" />
              <div class="mt-2" style="font-weight: 600; font-size: .9rem">
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <p>Atas perhatian dan kesadaran Bapak/Ibu/Saudara/i, Kami ucapkan Terimakasih.</p>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      instructions: [
        {
          icon:
            "https://ik.imagekit.io/ceremonyku/handwash_2x.png",
          title: "Mencuci Tangan",
        },
        {
          icon:
            "https://ik.imagekit.io/ceremonyku/mask_2x.png",
          title: "Menggunakan Masker",
        },
        {
          icon:
            "https://ik.imagekit.io/ceremonyku/social-distancing_2x.png",
          title: "Menjaga Jarak",
        },
        {
          icon:
            "https://ik.imagekit.io/ceremonyku/handsanitizer_2x.png",
          title: "Menggunakan Hand Sanitizer",
        },
        {
          icon:
            "https://ik.imagekit.io/ceremonyku/shake_2x.png",
          title: "Tidak Berjabat Tangan",
        },
      ],
    };
  },
};
</script>